import { fetcher } from "pages/_app";
import useSWRInfinite from "swr/infinite";
import { PaginationMeta } from "types";

export const useSWRPagination = <D, R = any>(url: string, params?: object) => {
    const getKey = (pageIndex: number, previousPageData: any) => {
        if (previousPageData?.next_page_url === null) return null;

        if (!url.includes("?")) return `${url}?page=${pageIndex + 1}`;

        if (params) return [`${url}&page=${pageIndex + 1}`, params];
        return `${url}&page=${pageIndex + 1}`;
    };
    const methods = useSWRInfinite<PaginationMeta<D>, R>(getKey, (key, init) => fetcher(key, init, true), {
        errorRetryInterval: 2000,
    });
    return methods;
};
